export const select2DefaultOption = {
    placeholder: "",
    minimumResultsForSearch: 1,
    templateResult: null
}
